// // 使用示例
// const platformManager = PlatformManager.getInstance()
// platformManager.initialize()
// console.log('Form:', platformManager.getForm())
// console.log('TK:', platformManager.getTk())
// console.log('Redirect Link:', platformManager.getRedirectLink())
import { transfer2erp } from '@/api/common'
import { GlobalStore } from '@/store/modules/global'
import useUserStore from '@/store/modules/user'
import { ref } from 'vue'

class PlatformManager {
  private static instance: PlatformManager
  private readonly formKey = '_&_platform_form'
  private readonly tkKey = '_&_platform_tk'

  public loading = ref(false)

  constructor() {}

  // 获取单例实例
  public static getInstance(): PlatformManager {
    if (!PlatformManager.instance) {
      PlatformManager.instance = new PlatformManager()
    }
    return PlatformManager.instance
  }

  // 初始化数据：记录 form 和 tk，并删除 URL 中的对应参数
  public initialize(): void {
    const urlParams = new URLSearchParams(window.location.search)

    // 记录 form 和 tk 到 localStorage
    const from = urlParams.get('from')

    if (from) localStorage.setItem(this.formKey, from)

    // 删除 URL 中的 form 和 tk 参数
    urlParams.delete('from')
    // 更新 URL
    let newUrl = window.location.pathname
    const queryString = urlParams.toString()

    if (queryString.length > 0) {
      newUrl += `?${queryString}`
    }

    window.history.replaceState({}, document.title, newUrl)
  }

  // 清除数据：从 localStorage 中移除 form 和 tk
  public clearData(): void {
    localStorage.removeItem(this.formKey)
    localStorage.removeItem(this.tkKey)
  }

  // 获取跳转链接的方法
  public getRedirectLink(): string {
    const from = localStorage.getItem(this.formKey)
    if (from === 'ud') {
      return '链接2'
    } else if (from === 'wiio') {
      return '链接2'
    }
    return '默认链接'
  }

  // 获取记录的 form
  public getForm(): string | null {
    return localStorage.getItem(this.formKey)
  }

  // 获取记录的 tk
  public getTk(): string | null {
    return localStorage.getItem(this.tkKey)
  }
  public enable(): boolean {
    return true
  }
  public prehandle(): void {
    const from = localStorage.getItem(this.formKey)
    if (from === null) {
      const userInfo = localStorage.getItem('userInfo')
      try {
        const userInfoObj = JSON.parse(userInfo)
        localStorage.setItem(this.formKey, userInfoObj.platform?.toLowerCase())
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    }
  }
  public getPushBtnName(): string {
    if (!this.enable()) {
      return null
    }
    this.prehandle()
    const from = localStorage.getItem(this.formKey)

    if (from === 'wiio') {
      return 'Wiio Dropshipping'
    }
    return 'USAdrop Dropshipping'
  }

  public async jumpToPlatformLink(): Promise<void> {
    this.prehandle()
    this.loading.value = true
    try {
      const from = localStorage.getItem(this.formKey)
      const userStore = useUserStore()
      const token = userStore?.getToken()

      const platform = from || ''

      const res = await transfer2erp(token, platform)
      if (res.data === null) {
        const globalStore = GlobalStore()
        const language = globalStore.language

        const messages: any = {
          en: {
            contactMsg: 'Please contact your sales agent!'
          },
          es: {
            contactMsg: '¡Por favor contacte a su agente de ventas!'
          },
          pt: {
            contactMsg: 'Por favor, entre em contato com seu agente de vendas!'
          }
        }
        const langMessages = messages[language] || messages.en

        ElMessage.error(langMessages.contactMsg)
        return
      }

      // 根据 form 的值决定跳转的目标
      if (from === 'wiio') {
        const reswiioToken = res.data.Result
        const udHome = import.meta.env.VITE_WIIO_HOME
        window.open(`${udHome}?form=ny&wtk=${reswiioToken}`)
        return
      }
      const resToken = res.data.Result.Token
      // if (from === 'ud') {
      const udHome = import.meta.env.VITE_UD_HOME
      window.open(`${udHome}?form=ny&tk=${resToken}`)
      // }
    } catch (error) {
      console.error('请求失败:', error)
    } finally {
      this.loading.value = false
    }
  }

  public async jumpToRechargePage(targetURL: any): Promise<void> {
    const from = localStorage.getItem(this.formKey)
    if (from !== 'wiio') {
      return
    }

    this.prehandle()
    this.loading.value = true
    try {
      const userStore = useUserStore()
      const token = userStore?.getToken()

      const platform = from || ''

      const res = await transfer2erp(token, platform)
      if (res.data === null) {
        const globalStore = GlobalStore()
        const language = globalStore.language

        const messages: any = {
          en: {
            contactMsg: 'Please contact your sales agent!'
          },
          es: {
            contactMsg: '¡Por favor contacte a su agente de ventas!'
          },
          pt: {
            contactMsg: 'Por favor, entre em contato com seu agente de vendas!'
          }
        }
        const langMessages = messages[language] || messages.en
        ElMessage.error(langMessages.contactMsg)

        return
      }

      // 根据 form 的值决定跳转的目标
      if (from === 'wiio') {
        const reswiioToken = res.data.Result
        window.open(`${targetURL}?form=ny&wtk=${reswiioToken}`)
        return
      }
      const resToken = res.data.Result.Token
      window.open(`${targetURL}?form=ny&tk=${resToken}`)
    } catch (error) {
      console.error('请求失败:', error)
    } finally {
      this.loading.value = false
    }
  }

  public redirectToPlatformLoginLink(): void {
    this.prehandle()
    const from = localStorage.getItem(this.formKey)
    if (from === 'wiio') {
      const udLogin = import.meta.env.VITE_WIIO_HOME
      window.location.href = `${udLogin}?from=ny`
      return
    }
    // if (form === 'ud') {
    const udHome = import.meta.env.VITE_UD_Login
    window.location.href = `${udHome}?from=ny`
  }
}

// 单例模式，确保整个应用只使用一个事件总线实例
const platformManager = new PlatformManager()
export default platformManager
